import React from 'react';
import { Box } from '@common-fe/common-fe';

import { ForfeitureSide } from '../ForfeitureReport.types';

import ForfeitureSidePickerItem from './ForfeitureSidePickerItem';

interface Props {
  value: ForfeitureSide;
  onChangeValue: (value: ForfeitureSide) => void;
  disabled?: boolean;
}

const ForfeitureSidePicker: React.FC<Props> = ({ value, onChangeValue, disabled }) => {
  return (
    <Box direction="row" margin={{ right: 'spacing16' }}>
      <Box margin={{ right: 'spacing8' }}>
        <ForfeitureSidePickerItem
          testId="forfeiture_by-employee_toggle-button"
          onClick={() => onChangeValue(ForfeitureSide.ByEmployer)}
          checked={value === ForfeitureSide.ByEmployer}
          disabled={disabled}
        >
          By Employee
        </ForfeitureSidePickerItem>
      </Box>
      <ForfeitureSidePickerItem
        testId="forfeiture_by-transaction_toggle-button"
        onClick={() => onChangeValue(ForfeitureSide.ByTransaction)}
        checked={value === ForfeitureSide.ByTransaction}
        disabled={disabled}
      >
        By Transaction
      </ForfeitureSidePickerItem>
    </Box>
  );
};

export default ForfeitureSidePicker;
